module.exports = __webpack_public_path__ + "img/img10.3db66f1d.png";